import React, {FC} from 'react';
import styles from './Button.module.css';
import {IButton} from "../../../../declarations/types";

export const Button: FC<IButton> = (props) => {
  const {
    children,
    ...rest
  } = props;

  return (
    <button className={styles.enterBtn} type="button" {...rest}>
      {children}
    </button>
  );
};
